import React from 'react';
import PropTypes from 'prop-types';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;
function FallbackScreen(props) {
	return (
		<Dialog
			open={true}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
		>
			<DialogContent>
				<DialogContentText variant='body1' color='default'>
					{props.isExtensionError
						?
						localize('fallback-screen-message-browser-extension')
						:
						localize('fallback-screen-message')}
				</DialogContentText>
			</DialogContent>
			<DialogActions>
				<Button
					variant='contained'
					color='primary'
					onClick={() => props.reload(true)}
				>
					{localize('fallback-screen-reload')}
				</Button>
			</DialogActions>
		</Dialog>
	);
}

FallbackScreen.propTypes = {
	reload: PropTypes.func.isRequired,
	isExtensionError: PropTypes.bool,
};
  
export default FallbackScreen;


// WEBPACK FOOTER //
// ./src/containers/ErrorBoundary/FallbackScreen.js